import { API_ROOT_URL } from '@/lib/constants/api';
import { apiFetch } from '@/lib/utils/apiFetch';
import type { AdminFiberSetting, UpdateAdminFiberSettingBody } from './types';

/**
 * Platform-wide fiber rules, served under `/api/admin/fiber/settings` on
 * `API_ROOT_URL`.
 *
 * Named `…Admin…` to keep them apart from `/v3/fiber/settings`, the
 * customer-facing read of the same rows.
 */

/**
 * Every setting, ordered by key, in one response.
 *
 * Takes no query string: the route declares no parameters at all, which is why
 * the table has no pagination. Answers `{ data, metadata }` with no
 * `pagination` — the hook unwraps `data`.
 */
export async function fetchAdminFiberSettings(): Promise<{
  data: AdminFiberSetting[];
}> {
  return apiFetch<{ data: AdminFiberSetting[] }>(
    '/api/admin/fiber/settings',
    undefined,
    API_ROOT_URL,
  );
}

/**
 * Updates one setting's value.
 *
 * A PATCH on the collection, not on a record: the row is identified by `key`
 * inside the body, and the route answers with the single updated setting in
 * the `{ data, metadata }` envelope.
 */
export async function updateAdminFiberSetting(
  body: UpdateAdminFiberSettingBody,
): Promise<{ data: AdminFiberSetting }> {
  return apiFetch<{ data: AdminFiberSetting }>(
    '/api/admin/fiber/settings',
    { method: 'PATCH', body: JSON.stringify(body) },
    API_ROOT_URL,
  );
}
